'use client'

import { Text } from '@/components/ui/text'
import { Flex } from '@/styled-system/jsx'
import chroma from 'chroma-js'
import { memo, useCallback, useMemo, useState, type CSSProperties } from 'react'
import OddsTable from '../shared/OddsTable'

export type PlinkoSlotProps = {
  slot: number
  payout: number
  color: string
  profit?: number
  chance?: number
  arrowPosition?: string
}

const PlinkoSlot = memo(function PlinkoSlot({
  slot,
  payout,
  profit,
  chance,
  color,
  arrowPosition,
}: PlinkoSlotProps) {
  const [isHover, setIsHover] = useState(false)
  const shadowColor = useMemo(() => chroma(color).darken(1.5).hex(), [color])

  const handleMouseEnter = useCallback(() => {
    setIsHover(true)
  }, [])

  const handleMouseLeave = useCallback(() => {
    setIsHover(false)
  }, [])

  return (
    <>
      <Flex
        data-plinko-slot={slot}
        position='relative'
        h='full'
        cursor='help'
        rounded='0.3em'
        textAlign='center'
        boxShadow='0 0.2em 0 0 var(--shadow-color)'
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
        style={
          {
            background: color,
            '--shadow-color': shadowColor,
          } as CSSProperties
        }
      >
        <Text
          as='span'
          position='absolute'
          top={0}
          left={0}
          bottom={0}
          right={0}
          display='flex'
          alignItems='center'
          justifyContent='center'
          fontSize='0.75em'
          fontWeight='bold'
          color='rgba(0, 0, 0, 0.8)'
        >
          {payout}
          {payout < 1000 ? '×' : ''}
        </Text>
      </Flex>

      {profit !== undefined &&
      chance !== undefined &&
      arrowPosition !== undefined ? (
        <OddsTable
          profit={profit}
          chance={chance}
          arrowPosition={arrowPosition}
          isVisible={isHover}
        />
      ) : null}
    </>
  )
})

export default PlinkoSlot
